import { Row } from '../Grid/Grid';
import Icon from '../Icon/Icon';
import Text from '../Text/Text';
import Button from '../Button/Button';

function DialogHeader({ title, onClose }: DialogHeaderProps) {
  return (
    <Row justifyContent="space-between">
      <Text type="title">{title}</Text>
      <Button type="icon" data-testid="closeDialog" onClick={onClose}>
        <Icon name="close" />
      </Button>
    </Row>
  );
}

export default DialogHeader;
